import { CHECKOUT_CLEAR_ERROR, CHECKOUT_ERROR } from '../constants/ActionTypes'
import { FETCH_PROVINCES_ERROR, FETCH_PROVINCES_REQUEST, FETCH_PROVINCES_SUCCESS } from '@ynap/country-state/src/constants/ActionTypes'
import { SubmissionError } from 'redux-form'
import type GenericAction from './types/genericAction.types'

export type CheckoutErrorAction = GenericAction<
    typeof CHECKOUT_CLEAR_ERROR | typeof CHECKOUT_ERROR | typeof FETCH_PROVINCES_REQUEST | typeof FETCH_PROVINCES_SUCCESS | typeof FETCH_PROVINCES_ERROR,
    { error: { errorMessage: string | unknown; message: string } | SubmissionError }
>

const checkoutError = (state = '', action: CheckoutErrorAction) => {
    switch (action?.type) {
        case CHECKOUT_ERROR:
            return action.error instanceof SubmissionError ? '' : action.error.message || action.error.errorMessage
        case CHECKOUT_CLEAR_ERROR:
            return ''
        default:
            return isExternalAction(action) ? state : ''
    }
}

function isExternalAction(action: CheckoutErrorAction) {
    const { type = '' } = action || {}
    return String(type).indexOf('@@') !== -1 || [FETCH_PROVINCES_REQUEST, FETCH_PROVINCES_SUCCESS, FETCH_PROVINCES_ERROR].includes(type)
}

export default checkoutError
